<div class="form-group">
  <div class="row">
    <div class="col">
      <label for="machineTag" translate>Machine tag</label>
      @if (isLoadingMachineTags) {
        <span class="fa-solid fa-spinner fa-spin ml-1"></span>
      }
    </div>
    <div class="col-auto">
      <div class="form-check form-switch d-inline-flex">
        <input (change)="onIsTemplateChange()" [(ngModel)]="isTemplate"
               [disabled]="shouldDisableTemplateSlider"
               class="form-check-input"
               id="isTemplate"
               type="checkbox"
               role="switch">
        <label class="form-check-label ms-2" for="isTemplate" translate>Machine Template</label>
      </div>
    </div>
  </div>

  <ng-select (change)="onSelectTag($event)"
             [disabled]="templateFlagInitialValue || !isAdminOrHigher"
             [(ngModel)]="machineTag"
             [addTagText]="addMachineTagText"
             [addTag]="onAddTagEvent"
             [items]="possibleMachineTags"
             [loading]="isLoadingMachineTags"
             [searchable]="true"
             bindLabel="tag"
             bindValue="tag"
             id="machineTag">
    <ng-template ng-tag-tmp let-search="searchTerm">
      <strong translate>Add tag</strong>: <span [innerText]="search"></span>
    </ng-template>
  </ng-select>
</div>

@if (shouldShowReadOnlyControlsForTemplateMachine) {
  <div class="alert alert-info mb-0" translate>
    The machine tag and template flag cannot be changed on template machine.
  </div>
}

@if (shouldShowMachineBecomingTemplateWarning) {
  <div
      class="alert alert-info mb-0"
      [innerHTML]="machineBecomesTemplateMessage">
  </div>
}

@if (isNewTagAdded) {
  <div
      class="alert alert-info mb-0"
      [innerHTML]="machineIsSetAsTemplateMachine">
  </div>
}
